<!-- eslint-disable @angular-eslint/template/interactive-supports-focus, @angular-eslint/template/click-events-have-key-events -->
<div class="row">
    <div class="col-lg-12 col-12">
        <nav aria-label="breadcrumb">
            @if (breadcrumbs && breadcrumbs.length >= 2) {
                <ol class="breadcrumb m-0">
                    @for (breadcrumb of breadcrumbs; track breadcrumb.key; let last = $last) {
                        <li class="breadcrumb-item" [ngClass]="{ active: last }">
                            @if (!last) {
                                <div class="page-title" (click)="changeRouting(breadcrumb.value)">
                                    <a #tooltip="matTooltip" matTooltip="{{ breadcrumb.key }}" matTooltipPosition="below">{{
                                        breadcrumb.key | textTruncate: 12
                                    }}</a>
                                </div>
                            } @else {
                                <span #tooltip="matTooltip" matTooltip="{{ breadcrumb.key }}" matTooltipPosition="below">{{
                                    breadcrumb.key | textTruncate: 12
                                }}</span>
                            }
                        </li>
                    }
                </ol>
            } @else {
                <ol class="breadcrumb m-0">
                    @for (breadcrumb of breadcrumbs; track breadcrumb.key) {
                        <li class="breadcrumb-item">
                            <div class="page-title">
                                <span>{{ breadcrumb.key }}</span>
                            </div>
                        </li>
                    }
                </ol>
            }
        </nav>
        <p class="page-main-tile" #tooltip="matTooltip" matTooltip="{{ pageMainTitle }}" matTooltipPosition="below">{{ pageMainTitle }}</p>
    </div>
</div>
